import { render, staticRenderFns } from "./UsageStatistics.vue?vue&type=template&id=8dd835e6&scoped=true"
import script from "./UsageStatistics.vue?vue&type=script&lang=js"
export * from "./UsageStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd835e6",
  null
  
)

export default component.exports